import { useEffect, useRef, useState } from 'react';

export function ImageSlideshow({ images }) {
  const scrollRef = useRef(null);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el || images.length < 4) return;

    let animId;
    let scrollPos = 0;
    const speed = 0.5;

    const animate = () => {
      if (!isPaused && el) {
        scrollPos += speed;
        if (scrollPos >= el.scrollWidth / 2) {
          scrollPos = 0;
        }
        el.scrollLeft = scrollPos;
      }
      animId = requestAnimationFrame(animate);
    };

    animId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animId);
  }, [images, isPaused]);

  if (!images || images.length === 0) return null;

  // Double the images for seamless infinite scroll
  const displayImages = images.length >= 4 ? [...images, ...images] : images;

  return (
    <section className="border-b border-[#262626] py-6 overflow-hidden bg-[#0A0A0A]" data-testid="slideshow-section">
      <div
        ref={scrollRef}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        className="flex gap-4 px-4 overflow-x-auto scrollbar-hide"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        {displayImages.map((img, i) => (
          <div
            key={i}
            className="flex-shrink-0 w-[280px] h-[320px] sm:w-[320px] sm:h-[360px] border border-[#262626] overflow-hidden group"
          >
            <img
              src={img}
              alt={`Slide ${(i % images.length) + 1}`}
              className="w-full h-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
